import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "device-data",
  "use": "device-data-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"device-data\"><path d=\"M23.56 5.42A12.68 12.68 0 0017 3V1a14.89 14.89 0 017.85 2.85zM31 16a14.94 14.94 0 01-.6 4.19l-1.88-.7a13 13 0 00-3.43-12.78l1.29-1.53A14.94 14.94 0 0131 16z\" fill=\"currentColor\" /><circle cx=\"16\" cy=\"25.51\" r=\"1.5\" fill=\"currentColor\" /><path d=\"M27.84 21.38A13.17 13.17 0 0123 27V8a1 1 0 00-1-1H10a1 1 0 00-1 1v19a13 13 0 016-24V1a15 15 0 1014.72 21.07zM11 9h10v19a13 13 0 01-5 1 12.83 12.83 0 01-5-1z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/device-data.svg
// module id = Ebg3
// module chunks = 39 44